import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { useState, useEffect, FormEventHandler } from 'react';
import Router, { useRouter } from 'next/router';

import { getAssetUrl } from '../../utils/common.utils';

import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import useTranslation from 'next-translate/useTranslation';

interface SearchBoxProps {
  placeholder: string;
}

const SearchBox = ({ placeholder }: SearchBoxProps) => {
  const [title, setTitle] = useState<string>('');

  const { lang } = useTranslation();
  const { query } = useRouter();

  const handleSubmit: FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();
    Router.push(`/blog/search/?q=${title}&lang=${lang}`);
  };

  const handleClearSearchInput = () => {
    setTitle('');
  };

  useEffect(() => {
    if (query.q && typeof query.q === 'string') {
      setTitle(query.q);
    }
  }, [query.q]);

  return (
    <div className={ivclass(' md:iv-max-w-[1024px] iv-w-full')}>
      <div
        className={ivclass(
          'search-box-wrapper',
          'iv-flex iv-items-center',
          'iv-h-[50px] sm:iv-h-[36px]',
          'iv-w-full',
          'iv-px-15 sm:iv-px-[7px]',
          'iv-bg-white-90',
          'iv-border iv-border-grey-7',
          'iv-rounded-[54px]',
          'iv-bg-grey-5',
          'iv-relative',
        )}
      >
        <ImageComponent
          elementype="native"
          src={getAssetUrl('blog', '/icons/search-icon.svg')}
          alt="search-icon"
          height={20}
          width={20}
        />
        <form onSubmit={handleSubmit} className={ivclass('iv-w-full')}>
          <input
            placeholder={placeholder}
            onChange={e => setTitle(e.target.value)}
            value={title}
            className={ivclass(
              'iv-text-body-xl sm:iv-text-body-m ',
              'iv-font-medium',
              'iv-w-full',
              'iv-px-[8px] iv-pt-[14px] iv-pb-[15px] sm:iv-px-[3px]',
              'iv-border-0 iv-rounded-r-3xl',
              'focus:iv-outline-none',
              'iv-bg-grey-5',
              'iv-h-[20px]',
            )}
          />
        </form>
        {title && (
          <button
            onClick={handleClearSearchInput}
            type="button"
            className={ivclass(
              'iv-absolute iv-right-[13px]',
              'focus:iv-outline-none',
            )}
          >
            <ImageComponent
              elementype="native"
              src={getAssetUrl('blog', '/icons/delete-search.svg')}
              alt="delete-search"
              height={20}
              width={20}
              loading="lazy"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBox;
